import React from "react";
import PropTypes from "prop-types";
import { Fragment } from "../../shared_components/little_router";

import BasePathActiveLink from "../../shared_components/base_path_active_link";
import LoadingSpinner from "../../shared_components/loading_spinner";

import GlobalSection from "../containers/sections/global_section";
import CitiesSection from "../containers/sections/cities_section";
import AllDataSection from "../containers/sections/all_data_section";
import AboutSection from "./sections/about_section";
import { makeSlug } from "../routes";

class Root extends React.Component {
  render () {
    return (
      <div className="tariff-survey-hub-react-app-root">
        <Fragment forRoute={makeSlug("global")}>
          <div className="datahub-description between-xs middle-xs">
            <p>The GWI tariff database includes detailed breakdowns of water, wastewater, and stormwater from 2011-2026 for 500+ cities worldwide. Our Tariff Survey Hub allows you to carry out advanced tariff data analysis to tariff prices, structure and cost per m³ for every location in the survey:</p>
            <ol>
              <li>Global tab: Compare and analyse tariff prices at the global level, including change in prices over time and countries by combined tariff prices.</li>
              <li>Cities tab: Drill down into the data at a city level, comparing tariff prices and breakdowns between cities, city averages and regions.</li>
              <li>All data: Conduct advanced analysis across the complete tariff survey dataset.</li>
            </ol>
          </div>
        </Fragment>
        <Fragment forRoute={makeSlug("cities")}>
          <div className="datahub-description between-xs middle-xs">
            <p>The GWI tariff database includes detailed breakdowns of water, wastewater, and stormwater from 2011-2026 for 500+ cities worldwide. Our Tariff Survey Hub allows you to carry out advanced tariff data analysis to tariff prices, structure and cost per m³ for every location in the survey:</p>
            <ol>
              <li>Global tab: Compare and analyse tariff prices at the global level, including change in prices over time and countries by combined tariff prices.</li>
              <li>Cities tab: Drill down into the data at a city level, comparing tariff prices and breakdowns between cities, city averages and regions.</li>
              <li>All data: Conduct advanced analysis across the complete tariff survey dataset.</li>
            </ol>
          </div>
        </Fragment>
        <nav>
          <BasePathActiveLink href={makeSlug("global", "change_map")}>
            Global
          </BasePathActiveLink>

          <BasePathActiveLink href={makeSlug("cities", "comparison")}>
            Cities
          </BasePathActiveLink>

          <a target="_blank" rel="noreferrer" href={"/data-hub/tariff-survey/"}>
            <i className="datahub-description-icon fa fa-external-link"></i>All data
          </a>
          <BasePathActiveLink href={makeSlug("about")}>
            <i className="datahub-description-icon fa fa-info"></i> About this data
          </BasePathActiveLink>
          <a target="_blank" rel="noreferrer" href={"https://www.globalwaterintel.com/documents/tariff-survey-2026"}>
            <i className="datahub-description-icon fa fa-external-link"></i>Download analysis
          </a>
        </nav>

        <div className="main-wrapper">
          <Fragment forRoute={makeSlug("global")}>
            <GlobalSection />
          </Fragment>

          <Fragment forRoute={makeSlug("cities")}>
            <CitiesSection />
          </Fragment>

          <Fragment forRoute={makeSlug("all_data")}>
            <AllDataSection />
          </Fragment>
          <Fragment forRoute={makeSlug("about")}>
            <AboutSection />
          </Fragment>
        </div>
        <LoadingSpinner show={this.props.isLoading} />
      </div>
    );
  }
}

Root.propTypes = {
  isLoading: PropTypes.bool.isRequired
};

export default Root;
